import { ITab, TSourceType, TWordsSearchStrings, TFilterStrings, TEditMode, TEditTextAria } from '#component/keywords/types';

export enum ECampaignType {
    SEACAT = 'seacat',
    AUTO = 'auto',
    SEARCH = 'search'
}

export enum ETabType {
    KEYWORDS = 'keywords',
    PLUSE = 'pluse',
    EXCLUDED = 'excluded',
    STRONG = 'strong',
    PHRASE = 'phrase'
}

export const mainTabsInitialValue: Array<ITab> = [
    {
        tab   : ETabType.KEYWORDS,
        active: true
    },
    {
        tab   : ETabType.PLUSE,
        active: false
    }
];

export const excludedTabsInitialValue: Array<ITab> = [
    {
        tab   : ETabType.EXCLUDED,
        active: true
    },
    {
        tab   : ETabType.STRONG,
        active: false
    },
    {
        tab   : ETabType.PHRASE,
        active: false
    }
];

export const MAX_VISIBLE_ITEMS = 7;

// код статуса запроса, когда выбранные фразы для исключения уже входят в фиксированные фразы
export const REQUEST_STATUS_CODE = 207;

export const SOURCE_TYPE: Record<string, TSourceType> = {
    AllRequests: 'all-requests',
    FromSearch : 'from-search',
    My         : 'my'
};

export const initialValueSearchStrings: TWordsSearchStrings = {
    excluded: '',
    keywords: '',
    phrase  : '',
    pluse   : '',
    strong  : ''
};

export const initialValueFilterStrings: Record<TFilterStrings, TSourceType> = {
    keywords: SOURCE_TYPE.AllRequests,
    pluse   : SOURCE_TYPE.AllRequests
};

export const initialEditMode: TEditMode = {
    phrase: false,
    strong: false
};

export const initialTextAriaValue: TEditTextAria = {
    phrase: '',
    strong: ''
};
